@if (isSelf) {
  <slotcom-friends-search></slotcom-friends-search>
}

@if (friends()) {
  <div class="friends-list">
    @if (friends()!.pendingFriendsCount > 0) {
      <div class="mb-2">
        <slotcom-p
          [text]="
            ('home.friends.pendingFriends' | translate) + ' (' + friends()!.pendingFriendsCount + ')'
          "></slotcom-p>
        <slotcom-friends-list [friends]="friends()!.pendingFriends"></slotcom-friends-list>
      </div>
    }
    <slotcom-p [text]="('home.friends.myFriends' | translate) + ' (' + friends()!.friendsCount + ')'"></slotcom-p>
    @if (friends()!.friendsCount === 0 && isSelf) {
      <div class="noFriends">
        {{ 'home.friends.noFriendsIsSelf' | translate }}
      </div>
    }
    @if (friends()!.friendsCount === 0 && !isSelf) {
      <div class="noFriends">
        {{ 'home.friends.noFriends' | translate }}
      </div>
    }
    @if (friends()!.friendsCount > 0) {
      <slotcom-friends-list [friends]="friends()!.friends"></slotcom-friends-list>
    }
  </div>
}
